const PREFIX = "LOGIN";

export class GET_SECRET_QUESTION_LIST {
  public static readonly type = `[${PREFIX}] GET SECRET_QUESTION LIST`;
}
export class SET_LOGIN_STATE {
  public static readonly type = `[${PREFIX}] SET LOGIN STATE`;
  constructor(public readonly payload: boolean) {}
}

export class SUBMIT_FIRST_TIME_LOGIN {
  public static readonly type = `[${PREFIX}] SUBMIT FIRST TIME LOGIN`;
  constructor(public readonly payload) {}
}

export class SAVE_USER_LOGIN_VALIDATION {
  public static readonly type = `[${PREFIX}] SAVE USER LOGIN VALIDATION`;
  constructor(public readonly payload) {}
}

export class GET_LOGIN_ALERT {
  public static readonly type = `[${PREFIX}] GET LOGIN ALERT`;
}

export class SUBMIT_RESET_PASSWORD {
  public static readonly type = `[${PREFIX}] SUBMIT LOGIN RESET PASSWORD`;
  constructor(public readonly payload) {}
}

export class SET_CONCURRENT_LOGIN_ERROR {
  public static readonly type = `[${PREFIX}] SET CONCURRENT LOGIN`;
  constructor(public readonly payload) {}
}
export class RESET_CONCURRENT_LOGIN_ERROR {
  public static readonly type = `[${PREFIX}] RESET CONCURRENT LOGIN`;
}

export class TESTING_EXPIRE {
  public static readonly type = `[${PREFIX}] TEST EXPIRE`;
}

export class SET_IE_NOTIFICATION {
  public static readonly type = `[${PREFIX}] SET IE NOTIFICATION`;
  constructor(public readonly payload: boolean) {}
}
